import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-6 md:px-10 max-w-4xl mx-auto text-center">
        <div className="rounded-2xl overflow-hidden mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Vibrant%20fashion%20inspiration%20flat%20lay%20with%20colorful%20trainers%20denim%20jacket%20and%20bold%20accessories%20on%20bright%20sunny%20yellow%20surface%2C%20energetic%20playful%20composition%2C%20editorial%20product%20photography%20with%20natural%20daylight%2C%20fun%20contemporary%20shopping%20aesthetic%20with%20rich%20color%20contrast&width=1200&height=600&seq=cta-fashion-v2-showcase&orientation=landscape"
            alt="Curated PandabuySpreadsheet fashion finds"
            className="w-full h-auto"
            loading="lazy"
          />
        </div>

        <h2 className="font-display text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
          Start Exploring the Best
          <br />
          <em className="font-display italic text-foreground-400">pandabuy spreadsheet</em> Now
        </h2>

        <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
          Browse 10,000+ verified finds across 14 categories. Updated daily with fresh spreadsheet links.
        </p>

        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center px-10 py-4 mt-8 text-base font-semibold rounded-full bg-foreground-900 text-white whitespace-nowrap hover:bg-foreground-800 transition-colors"
        >
          buy it now
          <i className="ri-arrow-right-line ml-2"></i>
        </a>
      </div>
    </section>
  );
}